export const appConfig = {
  region: 'ap-northeast-1',
  userPoolId: 'ap-northeast-1_lZ70xtiwN',
  userPoolClientId: '6j65r26kvg2vbkhjbp4e20l839',
  apiUrl: 'https://rss.develop.probud.io',
  wssUrl: 'wss://rss.develop.probud.io/wss',
};
